/**
 * DR-4850: when a stage failed and settled work covers every page, with no
 * page error, the badge and the green segment must not read as full success.
 * The page counts passed in stay unchanged.
 */
export function collapseFullSuccessOnStageError(args: {
  enabled: boolean;
  status: string | undefined;
  totalPages: number;
  settledCount: number;
  doneCount: number;
  errored: number;
}): { settledCount: number; doneCount: number } {
  const collapse =
    args.enabled &&
    args.status === 'error' &&
    args.totalPages > 0 &&
    args.errored === 0 &&
    args.settledCount >= args.totalPages;
  if (!collapse) {
    return { settledCount: args.settledCount, doneCount: args.doneCount };
  }
  return { settledCount: 0, doneCount: 0 };
}
